var CONSENT_KEY = 'museum-cookie-consent';
var CONSENT_COOKIE = 'museum_cookie_consent';
var METRIKA_KEY = 'museum-metrika-consent';

function hasConsentCookie() {
    return document.cookie.split(';').some(function (part) {
        return part.trim().indexOf(CONSENT_COOKIE + '=accepted') === 0;
    });
}

function clearConsentCookie() {
    document.cookie = CONSENT_COOKIE + '=; path=/; max-age=0; SameSite=Lax';
}

export function hasAnalyticsConsent() {
    if (localStorage.getItem(CONSENT_KEY) === 'declined') {
        return false;
    }

    return localStorage.getItem(CONSENT_KEY) === 'accepted' || hasConsentCookie();
}

export function hasMetrikaConsent() {
    if (!hasAnalyticsConsent()) {
        return false;
    }

    return localStorage.getItem(METRIKA_KEY) !== '0';
}

export function saveMetrikaPreference(enabled) {
    localStorage.setItem(METRIKA_KEY, enabled ? '1' : '0');
}

/** Яндекс.Метрика — только после принятия cookie и включённой настройки. */
export function loadAnalyticsIfConsented() {
    if (!hasMetrikaConsent()) {
        return;
    }

    var counterId = window.MUSEUM_YANDEX_METRIKA_ID;
    if (!counterId || document.querySelector('script[data-museum-metrika]')) {
        return;
    }

    var tagUrl = 'https://mc.yandex.ru/metrika/tag.js?id=' + counterId;

    if (document.querySelector('script[src*="mc.yandex.ru/metrika/tag.js"]')) {
        return;
    }

    (function (m, e, t, r, i, k, a) {
        m[i] =
            m[i] ||
            function () {
                (m[i].a = m[i].a || []).push(arguments);
            };
        m[i].l = 1 * new Date();
        for (k = 0; k < document.scripts.length; k++) {
            if (document.scripts[k].src === r) {
                return;
            }
        }
        a = e.createElement(t);
        a.async = 1;
        a.src = r;
        a.setAttribute('data-museum-metrika', '1');
        e.head.appendChild(a);
    })(window, document, 'script', tagUrl, 'ym');

    window.ym(counterId, 'init', {
        ssr: true,
        webvisor: true,
        clickmap: true,
        ecommerce: 'dataLayer',
        referrer: document.referrer,
        url: location.href,
        accurateTrackBounce: true,
        trackLinks: true,
    });

    if (!document.querySelector('[data-museum-metrika-noscript]')) {
        var noscript = document.createElement('noscript');
        noscript.setAttribute('data-museum-metrika-noscript', '1');
        var img = document.createElement('div');
        var inner = document.createElement('img');
        inner.src = 'https://mc.yandex.ru/watch/' + counterId;
        inner.alt = '';
        inner.style.cssText = 'position:absolute;left:-9999px;';
        img.appendChild(inner);
        noscript.appendChild(img);
        document.body.appendChild(noscript);
    }
}

export function revokeAnalyticsConsent() {
    clearConsentCookie();
    localStorage.setItem(CONSENT_KEY, 'declined');
    localStorage.setItem(METRIKA_KEY, '0');

    var script = document.querySelector('script[data-museum-metrika]');
    if (script) {
        script.remove();
    }

    var noscript = document.querySelector('[data-museum-metrika-noscript]');
    if (noscript) {
        noscript.remove();
    }

    if (window.ym && window.ym.a) {
        window.ym.a = [];
    }
}

export function initAnalytics() {
    loadAnalyticsIfConsented();
}
